import {Component, Input, OnInit} from '@angular/core';
import {Person} from '../../class/person';
import {WelfareResultService} from '../../service/welfare-result.service';
import {PersonKind} from '../../class/person-kind.enum';
import {PersonStatus} from '../../class/config/person-status';

@Component({
  selector: 'app-person-row',
  templateUrl: './person-row.component.html',
  styleUrls: ['./person-row.component.css']
})
export class PersonRowComponent implements OnInit {

  @Input()
  person: Person;
  personStatus: PersonStatus[] = [];
  personKind = PersonKind;

  constructor(private welfareProject: WelfareResultService) {
  }

  ngOnInit() {
    const isSingle = this.welfareProject.isSingle();
    if (!isSingle) {
      this.personStatus.push(
        {
          kind: PersonKind.HUSBAND,
          description: 'Marito / Convivente',
        },
        {
          kind: PersonKind.WIFE,
          description: 'Moglie / Convivente'
        },
        {
          kind: PersonKind.CHILD,
          description: 'Figlio'
        }
      );
    } else {
      this.personStatus.push(
        {
          kind: PersonKind.SINGLE,
          description: 'Capo famiglia'
        },
        {
          kind: PersonKind.CHILD,
          description: 'Figlio'
        }
      );
    }
  }

  removePerson() {
    this.welfareProject.removeFamilyMember(this.person);
  }
}
